import React, { useState } from 'react';
import './menu.css';
import items from './data';
import Categories from './Categories';
import List from './List';

const allCategories = ['all', ...new Set(items.map((item) => item.category))];

function Menu() {
  const [menuItems, setMenuItems] = useState(items);
  const [categories, setCategories] = useState(allCategories);

  const filterItems = (category) => {
    if (category === 'all') {
      setMenuItems(items);
      return;
    }
    const newItems = items.filter((item) => item.category === category);
    setMenuItems(newItems);
  };

  return (
    <main>
      <section className='menu-section'>
        <div className='title'>
          <h2>Our Menu</h2>
          <div className='underline'></div>
        </div>
        <Categories categories={categories} filterItems={filterItems} />
        <List items={menuItems} />
      </section>
    </main>
  );
}

export default Menu;
